const educationData = [
  {
    degree: "BSc in Computer Science",
    institution: "Eötvös Loránd University (ELTE)",
    location: "Budapest, Hungary",
    duration: "2022 – Apr 2027",
    logo: process.env.PUBLIC_URL + "/logos/ELTE_logo.png",
    description: [
      "Grade: 4.5/5.0",
      "Winner of the Stipendium Hungaricum Scholarship awarded by the Hungarian Government."
    ]
  }
];

export default educationData;